









import { Component, Vue, Emit, Prop } from 'vue-property-decorator'

@Component
export default class InputText extends Vue {
  @Prop({ default: 'text' }) type!: 'text' | 'number' | 'password'
  @Prop() value!: string
  @Prop() placeholder?: string

  @Emit() input(value: string) { value }
}
